import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { RuleSetRecord } from '../../Common/DataOwnerModels/RuleSetRecord';

export function useGetApprovedRuleSetsByRequest(requestId: string, shouldReload: boolean) {
  const [rulesetList, setRuleSetList] = useState<RuleSetRecord[]>(null);
  const [rulesetListLoading, setRuleSetListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    */
    if (!shouldReload) {
      setRuleSetListLoading(true);
      httpClient
        .get<RuleSetRecord[]>(`${__API_BASE_URL__}/tenant/getRuleSetsByRequest?requestId=${requestId}`, {
          resource: __CLIENT_ID__,
        })
        .then(({ data }) => {
          setRuleSetList(data);
          setRuleSetListLoading(false);
        });
    }
  }, [shouldReload]);

  return [rulesetList, rulesetListLoading] as const;
}

export function useGetApprovedRuleSetsByDataOwner(dataOwnerId: string, environment: number, shouldReload: boolean) {
  const [rulesetList, setRuleSetList] = useState<RuleSetRecord[]>(null);
  const [rulesetListLoading, setRuleSetListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    */
    if (!shouldReload) {
      setRuleSetListLoading(true);
      httpClient
        .get<RuleSetRecord[]>(
          `${__API_BASE_URL__}/tenant/getApprovedRuleSetsByTenant?tenantId=${dataOwnerId}&environment=${environment}`,
          {
            resource: __CLIENT_ID__,
          }
        )
        .then(({ data }) => {
          data?.map((x) => {
            x.environment = environment;
          });
          setRuleSetList(data);
          setRuleSetListLoading(false);
        });
    }
  }, [shouldReload]);

  return [rulesetList, rulesetListLoading] as const;
}
